import React from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { css, keyframes } from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties, b as _extends } from './_rollupPluginBabelHelpers-b3c9b1cd.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  animation: ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var size = css(["", ";"], function (_ref) {
  var theme = _ref.theme;
  return "\n  width: ".concat(theme.components.loader.size, ";\n  height: ").concat(theme.components.loader.size, ";\n  ");
}); // Part of the animation

var rotate360 = keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]); // Return the animation

var animation = css(["", " ", ";"], rotate360, function (_ref2) {
  var theme = _ref2.theme;
  return "\n    ".concat(theme.components.loader.animations.speed, "\n    ").concat(theme.components.loader.animations.type, "\n    infinite;\n  ");
}); // Return the color

var borders = css(["", ";"], function (_ref3) {
  var color = _ref3.color,
      theme = _ref3.theme;
  return "\n  border:\n    ".concat(theme.components.loader.borders.thickness, "\n    solid\n    ").concat(theme.components.loader.colors.backgroundColor, ";\n  border-top: ").concat(theme.components.loader.borders.thickness, " solid;\n  border-top-color: ").concat(theme.colors[color] ? theme.colors[color] : color || theme.components.loader.colors.colorIndicator, ";\n  border-radius: ").concat(theme.components.loader.borders.radius, ";\n ");
});
var StyledLoader = styled.div(_templateObject(), animation, borders, size);

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * A Loader, nothing special for the moment.
 *
 */

var Loader = function Loader(_ref) {
  var color = _ref.color,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["color", "variant"]);

  return React.createElement(StyledLoader, _extends({
    color: color,
    variant: variant
  }, rest));
};

Loader.defaultProps = {
  color: null,
  variant: 'circle'
};
Loader.propTypes = {
  /**
   * The color of the Loader content.
   */
  color: PropTypes.string,

  /**
   * The Loader type, at the moment the only type provided is circle.
   */
  variant: PropTypes.oneOf(['circle'])
};
/** @component */

var index = styled(Loader)(_templateObject$1());

export default index;
